<template></template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{

    fechaFinal(fechaCurso) {
      //Formato fecha es año-mes-dia
      var objDate = new Date(fechaCurso);

			const dia = objDate.toLocaleDateString("es-ES", { day: "numeric" }),
			      mes = objDate.toLocaleDateString("es-ES", { month: "long" }),
			      año = objDate.toLocaleDateString("es-ES", { year: "numeric" });

			return dia + " " + mes + " " + año; 
		}
  }
}
</script>